import { Component } from 'react';

export class TooltipQuestionMarkSVG extends Component<
    React.SVGProps<SVGSVGElement>
> {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                {...this.props}
            >
                <path
                    d="M9.8 13.1v-1.8c0-.1 0-.2-.1-.2s-.2-.1-.3-.1H7.6c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v1.8c0 .1 0 .2.1.2.1.1.1.1.2.1h1.8c.1 0 .2 0 .2-.1s.2-.1.2-.2zm2.4-6.4c0-.6-.2-1.1-.5-1.5-.4-.5-.8-.8-1.3-1.1-.6-.3-1.1-.4-1.7-.4-1.5 0-2.7.7-3.5 2-.1.2-.1.3.1.4l1.2.9s.1.1.2.1.2 0 .2-.1c.3-.4.6-.7.8-.9.3-.1.6-.2.9-.2.3 0 .6.1.8.2.2.2.4.4.4.6 0 .2-.1.4-.2.6s-.4.3-.7.4c-.4.2-.7.5-1.1.8-.3.4-.5.8-.5 1.2v.3c0 .1 0 .2.1.2.1.1.1.1.2.1h1.8c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2s.1-.3.2-.5.3-.3.5-.5c.2-.1.4-.2.5-.3.1-.1.3-.2.4-.3.2-.2.3-.3.4-.5.1-.1.2-.3.3-.6s.2-.3.2-.6zm3.6 1.8c0 1.3-.3 2.5-1 3.7s-1.5 2-2.7 2.7-2.3 1-3.7 1-2.5-.3-3.7-1-2-1.5-2.7-2.7-1-2.3-1-3.7.3-2.5 1-3.7 1.5-2 2.7-2.7 2.3-1 3.7-1 2.5.3 3.7 1 2 1.5 2.7 2.7 1 2.4 1 3.7z"
                    fill="#565656"
                />
            </svg>
        );
    }
}
